module.exports = __webpack_public_path__ + "static/media/ask-question.99132d8c.svg";